import * as Yup from "yup";

const LogTransferSchema = Yup.object().shape({
  amount: Yup.number().required("Amount is required"),
  screenshot: Yup.string().required("Image is required"),
});

export default LogTransferSchema;
